<template>
  <div>
    <v-autocomplete
      ref="batchAutocomplete"
      v-model="batch"
      :disabled="disabled || loading"
      :items="batches"
      item-value="_id"
      item-text="UID"
      :return-object="returnObject"
      :loading="loading"
      hide-details
      outlined
      dense
      background-color="white"
      clearable
      class="rounded-lg"
      :label="$t('batch.batch')"
      @focus="attachScroll"
    >
      <template v-slot:item="{ item }">
        <div class="d-flex justify-start text-start">
          {{ item.UID }}
        </div>
      </template>

      <template v-slot:append-item>
        <div
          v-if="infiniteLoading && batches.length < totalCount"
          class="pa-2"
        >
          <v-progress-linear indeterminate />
        </div>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { doQuery } from "@/app/core-module/util/graphqlHelper";

export default {
  name: "BatchesDropDown",

  props: {
    value: null,
    disabled: {
      type: Boolean,
      default: false,
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: false,
      infiniteLoading: false,
      hasLoadingError: false,

      pageInput: {
        skip: 0,
        limit: 50,
      },

      batches: [],
      totalCount: 0,

      scrollAttached: false,
    };
  },

  computed: {
    batch: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  created() {
    this.getBatches();
  },

  beforeDestroy() {
    this.removeScroll();
  },

  methods: {
    async getBatches() {
      if (this.loading || this.infiniteLoading) return;

      if (this.pageInput.skip === 0)
        this.loading = true;
      else
        this.infiniteLoading = true;

      try {
        const { data } = await doQuery({
          query: require("../api/query/getBatches.gql"),
          variables: {
            pageInput: {
              skip: this.pageInput.skip,
              limit: this.pageInput.limit,
            },
          },
        });

        const response = data?.getBatches;

        if (!response) {
          this.hasLoadingError = true;
          return;
        }

        const items = response.batches || [];

        items.forEach((item) => {
          if (!this.batches.some((x) => x._id === item._id)) {
            this.batches.push(item);
          }
        });

        this.totalCount = response.totalCount || this.batches.length;
      } catch (e) {
        console.error(e);
        this.hasLoadingError = true;
      } finally {
        this.loading = false;
        this.infiniteLoading = false;
      }
    },

    attachScroll() {
      this.$nextTick(() => {
        if (this.scrollAttached) return;

        const menu =
          this.$refs.batchAutocomplete?.$refs?.menu;

        const content =
          menu?.$refs?.content;

        if (!content) return;

        content.addEventListener("scroll", this.onScroll);

        this.scrollAttached = true;
      });
    },

    removeScroll() {
      const menu =
        this.$refs.batchAutocomplete?.$refs?.menu;

      const content =
        menu?.$refs?.content;

      if (content) {
        content.removeEventListener("scroll", this.onScroll);
      }

      this.scrollAttached = false;
    },

    onScroll(event) {
      const el = event.target;

      const reachedBottom =
        el.scrollTop + el.clientHeight >= el.scrollHeight - 20;

      if (!reachedBottom) return;

      if (this.loading) return;

      if (this.infiniteLoading) return;

      if (this.batches.length >= this.totalCount) return;

      this.pageInput.skip += this.pageInput.limit;

      this.getBatches();
    },
  },
};
</script>